'use client'

import { trackPhoneClick } from '@/lib/analytics'

/**
 * Centralized PhoneNumber component for consistent phone number display
 * across the website with automatic analytics tracking
 * 
 * @param {Object} props
 * @param {string} props.phone - Phone number to display (defaults to main business number)
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.displayFormat - Format: 'formatted' (default) or 'raw' (digits only for tel:)
 * @param {string} props.context - Context for analytics tracking (optional, e.g., 'footer', 'contact-section')
 */
export function PhoneNumber({
    phone = '+1 289-748-9666',
    className = '',
    displayFormat = 'formatted',
    context = null
}) {
    // Extract digits for tel: link (remove all non-digit characters)
    const telNumber = phone.replace(/\D/g, '')

    // Format display: if formatted, show as-is; if raw, show digits only
    const displayNumber = displayFormat === 'raw' ? telNumber : phone

    const handleClick = () => {
        // Track phone click using centralized analytics utility
        trackPhoneClick(phone, context)
    }

    return (
        <a
            href={`tel:${telNumber}`}
            onClick={handleClick}
            className={className}
        >
            {displayNumber}
        </a>
    )
}
